import React, { memo, useCallback } from 'react';
import { View } from 'react-native';
import { useAppSelector } from 'store/hooks';
import { Button, CardView, IconEdit, rem, Spacer } from 'design-system';
import { IconRocket } from 'design-system/icons/IconRocket';
import Squircle from 'design-system/Squircle';
import Text from 'design-system/Text';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { formatAutosaveLastPaymentDate } from '../utils';
import AutosaveStatus from './AutosaveStatus';
const AutomatedSavingsStatusCard = ({ noMarginBottom }) => {
    const navigation = useMainStackNavigation();
    const colors = useColors();
    const styles = useStyles(styleSet);
    const lastCollectionDate = useAppSelector((state) => state.pots.autosaveLastPaymentCollectionDate);
    const handlePress = useCallback(() => {
        navigation.navigateDeprecated('AutoSave');
    }, []);
    return (<CardView noMarginBottom={noMarginBottom} testID="autosaveStatusCard">
      <View style={styles.topContainer}>
        <Squircle color={colors.background.dark}>
          <IconRocket colorKey="brand"/>
        </Squircle>
        <Spacer w={16}/>
        <View style={styles.titleInfoContainer}>
          <Text Text-16>Autosave</Text>
          {!!lastCollectionDate && (<Text TextThin-14 Secondary>
              Last collection {formatAutosaveLastPaymentDate(lastCollectionDate)}
            </Text>)}
        </View>
      </View>
      <View style={styles.bottomContainer}>
        <View style={styles.row}>
          <View style={styles.flex}>
            <Text TextThin-14 Secondary>
              Status
            </Text>
          </View>
          <AutosaveStatus />
        </View>
        <Spacer h={24}/>
        <Button square brandReversed onPress={handlePress} title="Manage autosave" leftIconContainerStyle={styles.btnIconContainer} leftIcon={<IconEdit width={16} height={16} color={colors.text.textOnBrand}/>}/>
      </View>
    </CardView>);
};
const styleSet = createStyleSheets((colors) => ({
    topContainer: {
        padding: rem(16),
        flexDirection: 'row',
        borderBottomWidth: rem(1),
        borderBottomColor: colors.background.dark,
    },
    flex: {
        flex: 1,
    },
    titleInfoContainer: {
        flex: 1,
        justifyContent: 'center',
    },
    bottomContainer: {
        padding: rem(16),
    },
    btnIconContainer: {
        paddingRight: rem(8),
    },
    row: {
        alignItems: 'center',
        flexDirection: 'row',
    },
}));
export default memo(AutomatedSavingsStatusCard);
